import type { TFunction } from 'i18next';

import { CoverageHoursPairing } from './useCoverageHours';

export type CoverageHoursDeleteConfirmViewModel = {
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
};

export function createCoverageHoursDeleteConfirmViewModel(
  pairing: Pick<CoverageHoursPairing, 'category' | 'issue'>,
  t: TFunction
): CoverageHoursDeleteConfirmViewModel {
  return {
    title: t(
      'web.admin.serviceRequest.settings.coverageHours.delete.confirmTitle'
    ),
    message: t(
      'web.admin.serviceRequest.settings.coverageHours.delete.confirmMessage',
      {
        category: pairing.category,
        issue:
          pairing.issue ??
          t('web.admin.serviceRequest.settings.coverageHours.create.none'),
      }
    ),
    confirmText: t(
      'web.admin.serviceRequest.settings.coverageHours.delete.confirmButton'
    ),
    cancelText: t(
      'web.admin.serviceRequest.settings.coverageHours.delete.cancelButton'
    ),
  };
}
